//The contents of this file have been generated automatically. Do not edit this file.

import { z } from 'zod';
import {
    BonusTypeZod,
    CriteriaZod,
    BonusCreationViewZod,
    HttpError400Zod,
    HttpError401Zod,
    HttpError403Zod,
    HttpError422Zod,
    HttpError500Zod,
    HttpError503Zod,
} from './schemas';

export const ParamsTypeZOD = z.object({
    universe: z.string(),
    requestBody: z.union([z.object({
        name: z.string().optional().nullable(),
        terms: z.string().optional().nullable(),
        rewardType: z.union([BonusTypeZod, z.null()]).optional(),
        rewardName: z.string().optional().nullable(),
        rewardAmount: z.number().optional().nullable(),
        rewardExpiryAt: z.string().optional().nullable(),
        relativeExpiryDays: z.number().optional().nullable(),
        usageConditions: z.array(CriteriaZod).optional().nullable(),
        totalBet: z.number().optional().nullable(),
        playthrough: z.number().optional().nullable(),
        playthroughEligibleGames: z.array(z.string()).optional().nullable(),
        installmentCount: z.number().optional().nullable(),
        rewardInterval: z.number().optional().nullable(),
        scheduledReward: z.boolean().optional().nullable(),
        rewardDate: z.string().optional().nullable(),
        status: z.literal('draft'),
    }), z.object({
        bonusCreationId: z.string().optional().nullable(),
        name: z.string(),
        terms: z.string().optional().nullable(),
        rewardType: BonusTypeZod,
        rewardName: z.string(),
        rewardAmount: z.number(),
        rewardExpiryAt: z.string().optional().nullable(),
        relativeExpiryDays: z.number().optional().nullable(),
        usageConditions: z.array(CriteriaZod).optional(),
        totalBet: z.number().optional().nullable(),
        playthrough: z.number().optional().nullable(),
        playthroughEligibleGames: z.array(z.string()).optional().nullable(),
        installmentCount: z.number().optional().nullable(),
        rewardInterval: z.number().optional().nullable(),
        scheduledReward: z.boolean().optional().nullable(),
        rewardDate: z.string().optional().nullable(),
        status: z.literal('published'),
    })]),
});
export type ParamsType = z.TypeOf<typeof ParamsTypeZOD>;

const checkResponse = <A>(code: number, decoder: z.ZodType<A>, data: unknown): A => {
    const decodeResult = decoder.safeParse(data);
    if (decodeResult.success) {
        return decodeResult.data;
    }
    console.error('error details', {
        errors: decodeResult.error.errors,
        data
    });
    throw Error(`Response decoding error /bonus-creations/{universe} -> post -> ${code}`);
};


export const Response201ZOD = BonusCreationViewZod;
export type Response201Type = z.TypeOf<typeof Response201ZOD>;

export const Response400ZOD = HttpError400Zod;
export type Response400Type = z.TypeOf<typeof Response400ZOD>;

export const Response401ZOD = HttpError401Zod;
export type Response401Type = z.TypeOf<typeof Response401ZOD>;

export const Response403ZOD = HttpError403Zod;
export type Response403Type = z.TypeOf<typeof Response403ZOD>;

export const Response422ZOD = HttpError422Zod;
export type Response422Type = z.TypeOf<typeof Response422ZOD>;

export const Response500ZOD = HttpError500Zod;
export type Response500Type = z.TypeOf<typeof Response500ZOD>;

export const Response503ZOD = HttpError503Zod;
export type Response503Type = z.TypeOf<typeof Response503ZOD>;


const ExtraHeadersZod = z.record(z.string(), z.string());
type ExtraHeadersType = z.TypeOf<typeof ExtraHeadersZod>;


export type ApiCreateBonusCreationParamsType = ParamsType;


export type ApiCreateBonusCreationResponseType = 
    {
        status: 201;
        body: Response201Type;
    } | 
    {
        status: 400;
        body: Response400Type;
    } | 
    {
        status: 401;
        body: Response401Type;
    } | 
    {
        status: 403;
        body: Response403Type;
    } | 
    {
        status: 422;
        body: Response422Type;
    } | 
    {
        status: 500;
        body: Response500Type;
    } | 
    {
        status: 503;
        body: Response503Type;
    };

const convertHeaders = (params: Record<string, string | null | undefined>): Record<string, string> => {
    const result: Record<string, string> = {};

    for (const [name, value] of Object.entries(params)) {
        if (value !== null && value !== undefined) {
            result[name] = value;
        }
    }

    return result;
};

export const apiCreateBonusCreationRequest = async (
    api_url: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<ApiCreateBonusCreationResponseType> => {
    const ok = ParamsTypeZOD.safeParse(params);
    if (!ok.success) {
        console.error('Input parameters do not match the definition from openapi');
    }

    
        
    const query = '';
    const url = `${api_url}/bonus-creations/${params.universe}${query}`;
    

    const headers = convertHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        ...extraHeaders
    });

    const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(params.requestBody),
        credentials: 'include'
    });

    const status = response.status;

    let json = null;

    try {
        const text = await response.text();
        if (text !== '') {
            json = JSON.parse(text);
        }
    } catch (_err) {
        throw Error(`Http status ${status} - json was expected`);
    }
    
    if (status === 201) {
        return { status: 201, body: checkResponse(201, Response201ZOD, json) };
    }

    if (status === 400) {
        return { status: 400, body: checkResponse(400, Response400ZOD, json) };
    }

    if (status === 401) {
        return { status: 401, body: checkResponse(401, Response401ZOD, json) };
    }

    if (status === 403) {
        return { status: 403, body: checkResponse(403, Response403ZOD, json) };
    }

    if (status === 422) {
        return { status: 422, body: checkResponse(422, Response422ZOD, json) };
    }

    if (status === 500) {
        return { status: 500, body: checkResponse(500, Response500ZOD, json) };
    }

    if (status === 503) {
        return { status: 503, body: checkResponse(503, Response503ZOD, json) };
    }

    throw new Error(`apiCreateBonusCreationRequest - unhandled response ${status}`);
};
